import {Components} from "@webtech/webtech-ui-react/build/webtech-ui";
import React, {Component} from "react";

import {getRTPProfileValue} from "../../../Utils/rtp-profiles";
import {RTPProfilesFilterSelected} from "./RTPProfileConfigurationSection.component";
import RTPProfilesSearch from "./RTPProfilesSearch.component";

interface RTPProfilesFilterHeaderProps {
    defaultProfile: any;
    previousDefaultProfile: number | null;
    profiles: any[];
    settings: any[];
    selectedFilters: RTPProfilesFilterSelected;
    updateFilters: any;
}

class RTPProfilesFilterHeader extends Component<
    RTPProfilesFilterHeaderProps,
    {}
> {
    profileSelector: React.RefObject<Components.SelectMenu> = React.createRef();

    isDefaultProfile = profile =>
        this.props.defaultProfile &&
        `${profile.id}` === `${this.props.defaultProfile.id}`;

    getProfileLabel = profile =>
        profile.full_profile || profile.rtp || `${profile.id}`;

    setProfileFilter = selectedProfile => {
        this.props.updateFilters({
            ...this.props.selectedFilters,
            selectedProfile
        });
    };

    setSelectedGame = value => {
        if (!this.props.selectedFilters.selectedGames.includes(value)) {
            this.props.updateFilters({
                ...this.props.selectedFilters,
                selectedGames: [
                    ...this.props.selectedFilters.selectedGames,
                    value
                ]
            });
        }
    };

    removeGameFilter = event => {
        const value = event.currentTarget.getAttribute("data-value");
        this.props.updateFilters({
            ...this.props.selectedFilters,
            selectedGames: this.props.selectedFilters.selectedGames.filter(
                game => game !== value
            )
        });
    };

    clearFilters = () => {
        if (this.profileSelector.current) {
            this.profileSelector.current.selectItem({
                value: -1,
                label: "All RTP Profiles"
            });
            this.profileSelector.current.setDisplayString("All RTP Profiles");
        }
        this.props.updateFilters({
            selectedProfile: -1,
            selectedGames: []
        });
    };

    render() {
        const defaultProfileLabel = this.props.defaultProfile
            ? this.getProfileLabel(this.props.defaultProfile)
            : null;
        const previousProfile = this.props.profiles.find(
            profile =>
                `${profile.version_number}` ===
                `${this.props.previousDefaultProfile}`
        );
        const previousProfileLabel = previousProfile
            ? this.getProfileLabel(previousProfile)
            : this.props.previousDefaultProfile;
        const defaultProfileChanged =
            this.props.defaultProfile &&
            this.props.previousDefaultProfile !== null &&
            `${this.props.defaultProfile.version_number}` !==
                `${this.props.previousDefaultProfile}`;
        const profileItems = [
            {value: -1, label: "All RTP Profiles"},
            ...this.props.profiles.map(profile => ({
                value: getRTPProfileValue(profile),
                label: (
                    <span
                        className={`rtp-profile-option ${
                            this.isDefaultProfile(profile) ? "default" : ""
                        }`}
                    >
                        {this.getProfileLabel(profile)}
                        {this.isDefaultProfile(profile) && (
                            <span className="default-label">Default</span>
                        )}
                    </span>
                )
            }))
        ];

        return (
            <React.Fragment>
                <div id="rtp-profiles-filters-header">
                    <div className="filters">
                        <div className="col-6">
                            <label className="label">&nbsp;</label>
                            <RTPProfilesSearch
                                settings={this.props.settings}
                                selectedFilters={this.props.selectedFilters}
                                searchAction={this.setSelectedGame}
                            />
                        </div>
                        <div className="col-6">
                            <label className="label">RTP Profile</label>
                            <Components.SelectMenu
                                items={profileItems}
                                ref={this.profileSelector}
                                noValueLabel="RTP Profile"
                                value={
                                    this.props.selectedFilters.selectedProfile
                                }
                                onChange={this.setProfileFilter}
                            />
                        </div>
                    </div>
                    {defaultProfileLabel && (
                        <div
                            className={`rtp-default-note ${
                                defaultProfileChanged
                                    ? "default-changed"
                                    : ""
                            }`}
                        >
                            <p>
                                <i className="icon-exclamation-circle-light" />
                                {defaultProfileChanged ? (
                                    <React.Fragment>
                                        The market default RTP Profile has
                                        changed from&nbsp;
                                        <strong>{previousProfileLabel}</strong>
                                        &nbsp;to&nbsp;
                                        <strong>{defaultProfileLabel}</strong>
                                        &nbsp;since the previous configuration.
                                    </React.Fragment>
                                ) : (
                                    <React.Fragment>
                                        The current default RTP Profile is&nbsp;
                                        <strong>{defaultProfileLabel}</strong>.
                                    </React.Fragment>
                                )}
                            </p>
                        </div>
                    )}
                </div>
                <div className="row col-12 rtp-clear-filters">
                    <button onClick={this.clearFilters}>Clear All</button>
                </div>
                {this.props.selectedFilters.selectedGames.length > 0 && (
                    <div className="bullet-filters">
                        {this.props.selectedFilters.selectedGames.map(game => (
                            <div
                                className="filter-bullet"
                                key={`game-${game}`}
                            >
                                <p>{game}</p>
                                <span
                                    data-value={game}
                                    onClick={this.removeGameFilter}
                                    className="material-icons"
                                >
                                    clear
                                </span>
                            </div>
                        ))}
                    </div>
                )}
            </React.Fragment>
        );
    }
}

export default RTPProfilesFilterHeader;
